import { email, required, Validator } from '@/entities/validation';
import { ForgottenPasswordUser } from './model';

export const validate: Validator<ForgottenPasswordUser> = user => [
  ...required(user.email, 'email'),
  ...email(user.email, 'email'),
];
